var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYourIdeas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.985,
    height: 17.97,
    viewBox: "0 0 8.985 17.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-arrow-dropright",
    "data-name": "Icon ionic-md-arrow-dropright",
    d: "M13.5,9l8.985,8.985L13.5,26.97l2.592-8.985Z",
    transform: "translate(-13.5 -9)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYourIdeas);
export default __webpack_public_path__ + "static/media/your-ideas.bb731d7eac4f89b95201e52ded2d5270.svg";
export { ForwardRef as ReactComponent };